import React from 'react';

// YouTube Component for Storyblok
const YouTubeEmbed = ({ blok }) => {
  const { youtube_id, title, autoplay = false } = blok;

  if (!youtube_id) {
    return <div>YouTube video ID is required</div>;
  }

  const embedUrl = `https://www.youtube.com/embed/${youtube_id}${
    autoplay ? '?autoplay=1' : ''
  }`;

  return (
    <div className="youtube-embed-container">
      <div className="video-responsive">
        <iframe
          width="560"
          height="315"
          src={embedUrl}
          title={title || "YouTube video player"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default YouTubeEmbed;